import type { ContenidoAyuda, ItemAyuda } from "@/ui/AyudaVista";

/**
 * Ayuda de la pestaña Recordatorios del caso. Lo que antes iba en los
 * tooltips de «✓ Hecho» y «Cancelar», más cómo avisa un recordatorio (lo hace
 * `workers/recordatorios.py` del backend). El formulario y las acciones salen
 * solo a admin y soporte con el caso abierto, igual que en la pestaña.
 */
export function ayudaRecordatorios({ puedeEditar }: { puedeEditar: boolean }): ContenidoAyuda {
  const botones: ItemAyuda[] = puedeEditar
    ? [
        {
          label: "Recuérdame en … / El …",
          text: "Cuándo avisa: dentro de tantos minutos, horas o días (mínimo 5 minutos), o en una fecha y hora exactas, en la hora de tu equipo.",
        },
        {
          label: "Avisar a",
          text: "Toca a cada compañero para incluirlo o quitarlo; ya vienen marcados quien abrió el caso y el asignado.",
        },
        {
          label: "+ Agregar correo",
          text: "Suma un correo libre (el cliente, un tercero…): le llega el recordatorio por correo.",
        },
        {
          label: "Crear recordatorio",
          text: "Sale gris si falta el texto, cuándo o a quién avisar, o si es para dentro de menos de 5 minutos. La primera vez, el navegador te pide permiso para mostrar avisos.",
        },
        {
          label: "✓ Hecho",
          text: "Lo marca como hecho: ya no avisa.",
        },
        {
          label: "Posponer…",
          text: "Lo vuelve a programar: en 10 o 30 minutos, 1 o 3 horas, 1 día, hoy o mañana a las 9:30 a.m., o la fecha y hora que elijas. Vuelve a avisar aunque ya hubiera avisado.",
        },
        {
          label: "Cancelar",
          text: "Lo cancela: ya no avisa y se queda en la lista como «Cancelado».",
        },
      ]
    : [];

  return {
    manual: "recordatorios",
    intro: (
      <p>
        Los avisos programados del caso, incluidos los que se crearon desde la bitácora con
        «⏰ Recordatorio». «✓ Hecho», «Posponer» y «Cancelar» solo salen en los que siguen
        pendientes. Al cerrar el caso, sus recordatorios pendientes se cancelan solos —también
        los que todavía no avisaban— y la pestaña queda de solo lectura.
      </p>
    ),
    secciones: [
      { titulo: "Qué hace cada botón", items: botones },
      {
        titulo: "Qué significa cada indicador",
        items: [
          { label: "PROGRAMADO", text: "Todavía no llega su hora." },
          {
            label: "AVISADO",
            text: "Ya avisó y sigue pendiente: márcalo como hecho, pospónlo o cancélalo.",
          },
          {
            label: "COMPLETADO / CANCELADO",
            text: "Alguien lo marcó como hecho, o se canceló. Al cerrar el caso, los que seguían pendientes se cancelan solos.",
          },
          {
            label: "Avisa a · creado por · correo enviado",
            text: "A quién le avisa, quién lo creó y si ya salió su correo.",
          },
        ],
      },
      {
        titulo: "Cómo avisa",
        cuerpo: (
          <p>
            Al llegar la hora, cada compañero elegido lo ve en sus Alertas y, según lo que tenga
            activo en su perfil, le llega por correo, Telegram o al celular (aunque esté en su
            horario de silencio). Los correos libres reciben un correo. Todos los correos salen
            desde el correo empresarial de quien creó el recordatorio: si no lo tiene
            configurado, no sale ningún correo.
          </p>
        ),
      },
    ],
  };
}
